// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o_ZA","placeholdersHeader":"styles_placeholdersHeader__1mJAV","editorStyle":"styles_editorStyle__yKlI5","placeholdersBox":"styles_placeholdersBox__3NQzm"};